"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gettext = _interopRequireDefault(require("@eb/gettext"));

var _Icon = _interopRequireDefault(require("eventbrite_design_system/icon/Icon"));

var _ArrowRightChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/ArrowRightChunky"));

var _TicketChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/TicketChunky"));

var _CircleFill = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/CircleFill"));

var _mediaQueries = require("eventbrite_design_system/utils/mediaQueries");

var _Countdown = _interopRequireDefault(require("./Countdown"));

var _NotificationHeader = _interopRequireDefault(require("./NotificationHeader"));

var _Event = require("../context/Event");

require("./AttendeeTicketNotificationHeader.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LiveEventHeaderContent = function LiveEventHeaderContent() {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "eds-text-color--primary-brand--hover"
  }, (0, _gettext.default)('This event is live'));
};

var UpcomingEventHeaderContent = function UpcomingEventHeaderContent(_ref) {
  var eventStart = _ref.eventStart,
      hasDigitalContent = _ref.hasDigitalContent;
  //Translators: Numerical countdown occurs after the text
  //Translators: ex. Going live in 3:23:12
  var digitalContentText = (0, _gettext.default)('Going live in');
  var defaultText = (0, _gettext.default)('Event starts in');
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "eds-text-color--grey-800"
  }, hasDigitalContent ? digitalContentText : defaultText, ' ', /*#__PURE__*/_react.default.createElement(_Countdown.default, {
    eventStart: eventStart
  }));
};

var HEADER_CONTENT_MAP = {
  live_online: {
    iconContainerClass: 'notification-header__icon--small notification-header__icon--online-live',
    iconProps: {
      type: /*#__PURE__*/_react.default.createElement(_CircleFill.default, null),
      size: 'small',
      color: 'ui-orange'
    },
    HeaderContent: LiveEventHeaderContent
  },
  live_physical: {
    iconContainerClass: 'notification-header__icon--medium',
    iconProps: {
      type: /*#__PURE__*/_react.default.createElement(_TicketChunky.default, null),
      size: 'medium',
      color: 'ui-orange'
    },
    HeaderContent: LiveEventHeaderContent
  },
  upcoming: {
    iconContainerClass: 'notification-header__icon--medium',
    iconProps: {
      type: /*#__PURE__*/_react.default.createElement(_TicketChunky.default, null),
      color: 'grey-800',
      size: 'medium'
    },
    HeaderContent: UpcomingEventHeaderContent
  }
};

var AttendeeTicketNotificationHeader = function AttendeeTicketNotificationHeader(props) {
  var isEventLive = (0, _react.useContext)(_Event.LiveEventContext);
  var headerContentKey = isEventLive ? props.hasDigitalContent ? 'live_online' : 'live_physical' : 'upcoming';
  var _HEADER_CONTENT_MAP$h = HEADER_CONTENT_MAP[headerContentKey],
      iconContainerClass = _HEADER_CONTENT_MAP$h.iconContainerClass,
      iconProps = _HEADER_CONTENT_MAP$h.iconProps,
      HeaderContent = _HEADER_CONTENT_MAP$h.HeaderContent;
  return /*#__PURE__*/_react.default.createElement(_NotificationHeader.default, {
    containerClasses: (0, _mediaQueries.isMediumNarrowDown)() ? 'eds-text-bl' : 'eds-text-hs',
    renderIcon: function renderIcon(baseIconClass) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(baseIconClass, " ").concat(iconContainerClass)
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, iconProps));
    }
  }, /*#__PURE__*/_react.default.createElement(HeaderContent, props));
};

var AttendeeTicketNotificationContent = function AttendeeTicketNotificationContent(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(AttendeeTicketNotificationHeader, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "eds-text-bs eds-l-pad-top-2 eds-text-color--grey-700"
  }, props.eventName), /*#__PURE__*/_react.default.createElement("div", {
    className: "eds-l-pad-top-4"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "eds-text-weight--heavy eds-text-bs",
    href: props.ctaLinkUrl,
    onClick: props.onLinkClick,
    target: "_blank",
    rel: "noopener noreferrer"
  }, props.hasDigitalContent ? (0, _gettext.default)('Join now') : (0, _gettext.default)('View tickets'), ' ', /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: /*#__PURE__*/_react.default.createElement(_ArrowRightChunky.default, null),
    size: "xsmall",
    color: "ui-blue"
  }))));
};

AttendeeTicketNotificationContent.propTypes = {
  eventName: _propTypes.default.string,
  ctaLinkUrl: _propTypes.default.string,
  onLinkClick: _propTypes.default.func,
  hasDigitalContent: _propTypes.default.bool,
  eventStart: _propTypes.default.string
};
var _default = AttendeeTicketNotificationContent;
exports.default = _default;
//# sourceMappingURL=AttendeeTicketNotificationContent.js.map